<wr-new-data-table headerText="Rundgänge"
                   data-cy="inspection-overview"
                   localStorageIdentifier="internal-inspection-overview"
                   [loadItemsFunction]="loadInspections"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToInspection($event)"
                   (newClick)="add()"
                   [form]="form"
                   [isAdmin]="canCreate()">

  <ng-template dataTableFilter>
    @if (form) {
      <form [formGroup]="form" class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="datePicker">Zeitraum</label>
          <wr-date-range-picker id="datePicker" formControlName="selectedRange"
                                [showTodayButton]="true"></wr-date-range-picker>
        </div>
        <div class="filter-control-group">
          <label class="label" for="status">Status</label>
          <wr-status-select id="status" formControlName="status" [showEmptyOption]="true"></wr-status-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="inspectionType">Begehungsart</label>
          <wr-inspection-type-select id="inspectionType" formControlName="inspectionType"
                                     [showEmptyOption]="true"></wr-inspection-type-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="continuationNumber">Folgenummer</label>
          <input type="text" nbInput id="continuationNumber" min="0" formControlName="continuationNumber"
                 placeholder="Folgenummer...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="building">Gebäude</label>
          <wr-building-select id="building"
                              formControlName="building"
                              [tenantId$]="form.get('tenantId')?.valueChanges">
          </wr-building-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="tenant">Kunde</label>
          <wr-tenant-select id="tenant"
                            formControlName="tenantId"
                            [tenantType]="TenantTypeEnum.External"
                            [showEmptyOption]="true"></wr-tenant-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="regionSelect">Bereich</label>
          <wr-region-select id="regionSelect" formControlName="region" [tenantId$]="form.get('tenantId')?.valueChanges"></wr-region-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="teamSelect">Team</label>
          <wr-team-select id="teamSelect" formControlName="team"
                          [tenantId$]="form.get('tenantId')?.valueChanges"
                          [regionId$]="form.get('regionId')?.valueChanges"></wr-team-select>
        </div>

        <div class="filter-control-group">
          <label class="label" for="technicianId">Techniker*in</label>
          <wr-user-select id="technicianId" formControlName="technician" [tenantIds$]="tenantFilter$"></wr-user-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="clerkId">Sachbearbeiter*in</label>
          <wr-user-select id="clerkId" formControlName="clerk" [tenantIds$]="tenantFilter$"></wr-user-select>
        </div>
        <div class="filter-control-group">
          <label class="label" for="buildingCondition">Zustand</label>
          <wr-condition-select
            id="buildingCondition"
            formControlName="condition">
          </wr-condition-select>
        </div>
      </form>
    }
  </ng-template>

  <ng-template
    dataColumn
    let-inspection
    key="continuationNumber"
    display="FolgeNr">
    @if (inspection.continuationNumber) {
      <div>
        {{ inspection.continuationNumber }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="inspectionType"
    display="Art"
    [exportValue]="inspectionTypeExportValue">
    @if (inspection.inspectionType) {
      <div>{{ inspection.inspectionType | inspectionTypePipe }}</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="status"
    display="Status">
    @if (inspection.status) {
      <div>
        <wr-status-text [status]="inspection.status"></wr-status-text>
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="fromTimestamp"
    display="Datum">
    @if (inspection.fromTimestamp) {
      <div>
        {{ inspection.fromTimestamp | date: 'dd.MM.yyyy' }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="sendingTimestamp"
    display="Versendet am">
    @if (inspection.sendingTimestamp) {
      <div>
        {{ inspection.sendingTimestamp | date: 'dd.MM.yyyy' }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="address"
    exportKey="building.baseData.sectionText"
    display="Gebäude">
    <wr-building-badge [building]="inspection.building"></wr-building-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="technician"
    exportKey="technician.fullName"
    display="Techniker*in">
    <wr-user-badge [user]="inspection.technician"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="clerk"
    exportKey="clerk.fullName"
    display="Sachbearbeiter*in">
    <wr-user-badge [user]="inspection.clerk"></wr-user-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="tenant"
    exportKey="building.ownerTenant.name"
    display="Kunde">
    <wr-tenant-badge [tenant]="inspection.building.ownerTenant"></wr-tenant-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="condition"
    exportKey="condition.conditionValue"
    [exportDecimals]="2"
    display="Zustand"
    [sortable]="false">
    @if (inspection.condition.conditionValue) {
      <div>
        <wr-building-condition
          [condition]="inspection.condition.conditionValue"></wr-building-condition>
      </div>
    }
  </ng-template>
</wr-new-data-table>

